import { render, staticRenderFns } from "./EmployeeTypesTrashedView.vue?vue&type=template&id=29c9ecfe&"
import script from "./EmployeeTypesTrashedView.vue?vue&type=script&lang=js&"
export * from "./EmployeeTypesTrashedView.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeTypesTrashedView.vue?vue&type=style&index=0&id=29c9ecfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports